<template>
  <footer class="footer">
      <div class="disclaimer">
        <div class="container has-text-centered">
            Hecho con <b-icon icon="heart"></b-icon> por Tostatronic
        </div>
      </div>
      <div class="level">
        <div class="level-item"><b-icon size="is-medium" icon="facebook"></b-icon></div>
        <div class="level-item"><b-icon size="is-medium" icon="twitter"></b-icon></div>
        <div class="level-item"><b-icon size="is-medium" icon="instagram"></b-icon></div>
        <div class="level-item"><b-icon size="is-medium" icon="youtube"></b-icon></div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Dirección</p>
            <p class="has-text-weight-bold is-size-4-desktop">
              Tejedores 680, Col. Las Paz
              44860 Guadalajara, Jalisco
            </p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Llámenos</p>
            <p class="has-text-weight-bold is-size-4-desktop">3314575853</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Correo</p>
            <p class="has-text-weight-bold is-size-4-desktop">team@tostatronic.com</p>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
    name: 'Foot',
}
</script>

<style lang="scss" scoped>
  .disclaimer {
    padding-bottom: 2rem;
  }
  .footer {
    margin-top: 3rem;
  }
</style>